
export const LOGIN_TOKEN_KEY = 'login-token'

export function setLoginToken(token) {
  localStorage.setItem(LOGIN_TOKEN_KEY, token)
}

export function hasSavedLoginToken() {
  return !!localStorage.getItem(LOGIN_TOKEN_KEY)
}

export function getLoginToken() {
  return localStorage.getItem(LOGIN_TOKEN_KEY)
}

export function removeLoginToken() {
  return localStorage.removeItem(LOGIN_TOKEN_KEY)
}
